export default {
  // 发票管理
  insertTHInvoice: '/ygsjzs/lyInvoice/insertTHInvoice',
  updateLyInvoice: '/ygsjzs/lyInvoice/updateLyInvoice',
  deleteLyInvoice: '/ygsjzs/lyInvoice/deleteDataLyInvoice',
  updateLyInvoiceFile: '/ygsjzs/lyInvoice/updateLyInvoiceFile',
  selectLyInvoiceByInvoiceId: '/ygsjzs/lyInvoice/selectLyInvoiceByInvoiceId',
  selectLyInvoiceByPage: '/ygsjzs/lyInvoice/selectLyInvoiceByPage',
  // 发票抬头
  insertLyInvoiceHeader: '/ygsjzs/lyInvoiceHeader/insertLyInvoiceHeader',
  updateLyInvoiceHeader: '/ygsjzs/lyInvoiceHeader/updateLyInvoiceHeader',
  deleteDataLyInvoiceHeader: '/ygsjzs/lyInvoiceHeader/deleteDataLyInvoiceHeader',
  selectLyInvoiceHeaderByHeaderId: '/ygsjzs/lyInvoiceHeader/selectLyInvoiceHeaderByHeaderId',
  selectLyInvoiceHeaderByPage: '/ygsjzs/lyInvoiceHeader/selectLyInvoiceHeaderByPage'
}
